class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
      // ⬇ keep reset visibility in sync when navigating history
      FacetFiltersForm.updateResetVisibility(searchParams);
      FacetFiltersForm.updateSelectedFiltersCount(searchParams);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  // ⬇ Count applied filters from the query string
  // Replace the previous getAppliedFiltersCount with this:
static getAppliedFiltersCount(searchParamsString) {
  const params = new URLSearchParams(searchParamsString || "");
  let count = 0;
  let countedPrice = false; // treat price gte/lte as a single filter

  params.forEach((val, key) => {
    const value = String(val).trim();
    if (!key.startsWith("filter.") || value === "") return;

    // Handle price specially: gte/lte should count as ONE
    if (key.startsWith("filter.v.price.")) {
      if (!countedPrice) {
        // only increment once if either gte or lte is present
        count++;
        countedPrice = true;
      }
      return;
    }

    // Everything else counts normally (multi-selects count per value like Shopify pills)
    count++;
  });

  return count;
}


  // ⬇ Show/hide the reset element based on count
 static updateResetVisibility(searchParamsString) {
    const resetEl = document.querySelector(".collection__filters__reset");
    const resetEl2 = document.querySelector(".mobile-facets__clear");
    if (!resetEl) return;
    if (!resetEl2) return;
    const hasFilters = FacetFiltersForm.getAppliedFiltersCount(searchParamsString) > 0;
    resetEl.classList.toggle("hidden", !hasFilters);
    resetEl2.classList.toggle("hidden", !hasFilters);
}

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);

    // ⬇ Update reset visibility whenever we render based on current params
    FacetFiltersForm.updateResetVisibility(searchParams);
    FacetFiltersForm.updateSelectedFiltersCount(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
    static updateSelectedFiltersCount(searchParamsString) {
  const countSpans = document.querySelectorAll('span[data-selected-filters-count]');
  if (!countSpans.length) return;

  const count = FacetFiltersForm.getAppliedFiltersCount(searchParamsString);

  countSpans.forEach(span => {
    span.textContent = count;
  });
}


}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

// ⬇ Initialize reset button on first load
FacetFiltersForm.updateResetVisibility(FacetFiltersForm.searchParamsInitial);
FacetFiltersForm.updateSelectedFiltersCount(FacetFiltersForm.searchParamsInitial);


class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
    

      const rangevalue = document.querySelector(".slider .price-slider");

      const rangeInputvalue = document.querySelectorAll(".range-input input");

      let priceGap = 1;

      const priceInputvalue = document.querySelectorAll(".facets__price input");

      

      for (let i = 0; i < priceInputvalue.length; i++) {

        priceInputvalue[i].addEventListener("input", e => {

            let minp = parseInt(priceInputvalue[0].value);

            let maxp = parseInt(priceInputvalue[1].value);

            let diff = maxp - minp



            if (minp < 0) {

              alert("minimum price cannot be less than 0");

              priceInputvalue[0].value = 0;

              minp = 0;

            }



            if (maxp > 10000) {

              alert("maximum price cannot be greater than 10000");

              priceInputvalue[1].value = 10000;

              maxp = 10000;

            }



            if (minp > maxp - priceGap) {

              priceInputvalue[0].value = maxp - priceGap;

              minp = maxp - priceGap;



              if (minp < 0) {

                priceInputvalue[0].value = 0;

                minp = 0;

              }

            }



            if (diff >= priceGap && maxp <= rangeInputvalue[1].max) {

              if (e.target.id === "Filter-Price-GTE") {

                  rangeInputvalue[0].value = minp;

                  let value1 = rangeInputvalue[0].max;

                  rangevalue.style.left = `${(minp / value1) * 100}%`;

              }

              else {

                rangeInputvalue[1].value = maxp;

                let value2 = rangeInputvalue[1].max;

                rangevalue.style.right = `${100 - (maxp / value2) * 100}%`;

              }

            }

        });



        for (let i = 0; i < rangeInputvalue.length; i++) {

          rangeInputvalue[i].addEventListener("input", e => {

            let minVal = parseInt(rangeInputvalue[0].value);

            let maxVal = parseInt(rangeInputvalue[1].value);



            let diff = maxVal - minVal

            

            if (diff < priceGap) {

              if (e.target.className === "min-range") {

                rangeInputvalue[0].value = maxVal - priceGap;

              }

              else {

                rangeInputvalue[1].value = minVal + priceGap;

              }

            }

            else {

              priceInputvalue[0].value = minVal;

              priceInputvalue[1].value = maxVal;

              rangevalue.style.left = `${(minVal / rangeInputvalue[0].max) * 100}%`;

              rangevalue.style.right = `${100 - (maxVal / rangeInputvalue[1].max) * 100}%`;

            }

          });

        }

      }

    
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

// document.addEventListener("DOMContentLoaded", () => {
//   // Reusable function for both desktop and mobile
//   function initPriceSliders(context) {
//     const wrapper = context.querySelector(".filter__main");
//     if (!wrapper) return;

//     const rangeInputs = wrapper.querySelectorAll(".range-input input");
//     const priceSlider = wrapper.querySelector(".slider .price-slider");
//     const priceInputs = context.querySelectorAll(".facets__price input");
//     if (rangeInputs.length < 2 || priceInputs.length < 2) return;

//     let priceGap = 1;

//     // 💰 Text inputs (From / To)
//     priceInputs.forEach(input => {
//       input.addEventListener("input", e => {
//         let minp = parseFloat(priceInputs[0].value) || 0;
//         let maxp = parseFloat(priceInputs[1].value) || parseFloat(rangeInputs[1].max);
//         let diff = maxp - minp;

//         if (minp < 0) minp = 0;
//         if (maxp > rangeInputs[1].max) maxp = rangeInputs[1].max;
//         if (diff < priceGap) {
//           if (e.target === priceInputs[0]) minp = maxp - priceGap;
//           else maxp = minp + priceGap;
//         }

//         rangeInputs[0].value = minp;
//         rangeInputs[1].value = maxp;
//         priceSlider.style.left = `${(minp / rangeInputs[0].max) * 100}%`;
//         priceSlider.style.right = `${100 - (maxp / rangeInputs[1].max) * 100}%`;
//       });
//     });

//     // 🎚 Range sliders
//     rangeInputs.forEach(input => {
//       input.addEventListener("input", e => {
//         let minVal = parseFloat(rangeInputs[0].value);
//         let maxVal = parseFloat(rangeInputs[1].value);
//         let diff = maxVal - minVal;

//         if (diff < priceGap) {
//           if (e.target.classList.contains("min-range")) {
//             rangeInputs[0].value = maxVal - priceGap;
//           } else {
//             rangeInputs[1].value = minVal + priceGap;
//           }
//         } else {
//           priceInputs[0].value = minVal;
//           priceInputs[1].value = maxVal;
//           priceSlider.style.left = `${(minVal / rangeInputs[0].max) * 100}%`;
//           priceSlider.style.right = `${100 - (maxVal / rangeInputs[1].max) * 100}%`;
//         }
//       });
//     });
//   }

//   // Initialize both desktop and mobile
//   document.querySelectorAll("#Facet-2-template--19605387247771__main, #FacetMobile-2-template--19605387247771__main")
//     .forEach(el => initPriceSliders(el));

//   // If mobile filters are opened dynamically (AJAX/Drawer)
//   document.addEventListener("shopify:section:load", (e) => {
//     if (e.target.id.includes("FacetMobile-")) initPriceSliders(e.target);
//   });

//   // ⬇ Also ensure reset visibility is correct on DOM ready (in case theme defers JS)
//   FacetFiltersForm.updateResetVisibility(window.location.search.slice(1));
// });

document.addEventListener("DOMContentLoaded", () => {
  function initFacetPriceBinding(facet) {
    if (!facet || !(facet.classList.contains("facet__mobile") || facet.classList.contains("facet__desktop"))) return;

    // Avoid double-binding after re-renders
    if (facet.dataset.priceBindingDone === "1") return;
    facet.dataset.priceBindingDone = "1";

    // Sliders (inside wrapper)
    const wrapper = facet.querySelector(".filter__main");
    if (!wrapper) return;

    const rangeInputs = wrapper.querySelectorAll(".range-input input"); // min-range / max-range
    const priceSlider = wrapper.querySelector(".slider .price-slider");
    if (rangeInputs.length < 2 || !priceSlider) return;

    // Text inputs (sibling <price-range class="facets__price"> …)
    const priceInputs = facet.querySelectorAll(".facets__price input");
    if (priceInputs.length < 2) return;

    const priceGap = 1;

    // ---- Text inputs → Range sliders + bar
    priceInputs.forEach(input => {
      input.addEventListener("input", e => {
        let minp = parseFloat(priceInputs[0].value) || 0;
        let maxp = parseFloat(priceInputs[1].value) || parseFloat(rangeInputs[1].max);
        const maxAllowed = parseFloat(rangeInputs[1].max);

        if (minp < 0) minp = 0;
        if (maxp > maxAllowed) maxp = maxAllowed;

        if (maxp - minp < priceGap) {
          if (e.target === priceInputs[0]) minp = Math.max(0, maxp - priceGap);
          else maxp = Math.min(maxAllowed, minp + priceGap);
        }

        rangeInputs[0].value = minp;
        rangeInputs[1].value = maxp;
        priceSlider.style.left = `${(minp / rangeInputs[0].max) * 100}%`;
        priceSlider.style.right = `${100 - (maxp / rangeInputs[1].max) * 100}%`;
      });
    });

    // ---- Range sliders → Text inputs + bar
    rangeInputs.forEach(input => {
      input.addEventListener("input", e => {
        let minVal = parseFloat(rangeInputs[0].value);
        let maxVal = parseFloat(rangeInputs[1].value);

        if (maxVal - minVal < priceGap) {
          if (e.target.classList.contains("min-range")) {
            rangeInputs[0].value = maxVal - priceGap;
            minVal = maxVal - priceGap;
          } else {
            rangeInputs[1].value = minVal + priceGap;
            maxVal = minVal + priceGap;
          }
        }

        priceInputs[0].value = minVal;
        priceInputs[1].value = maxVal;
        priceSlider.style.left = `${(minVal / rangeInputs[0].max) * 100}%`;
        priceSlider.style.right = `${100 - (maxVal / rangeInputs[1].max) * 100}%`;
      });
    });
  }

  // Init for all facet containers present now
  document.querySelectorAll(".facet__mobile, .facet__desktop").forEach(initFacetPriceBinding);

  // Re-init when Shopify re-renders sections
  document.addEventListener("shopify:section:load", (e) => {
    e.target.querySelectorAll(".facet__mobile, .facet__desktop").forEach(initFacetPriceBinding);
  });

  // Extra: when mobile drawer opens and injects content
  document.addEventListener("menu-drawer:open", (e) => {
    if (!e.target) return;
    e.target.querySelectorAll(".facet__mobile").forEach(initFacetPriceBinding);
  });

  // Keep reset visibility and count correct on load
  const currentParams = window.location.search.slice(1);
  FacetFiltersForm.updateResetVisibility(currentParams);
  FacetFiltersForm.updateSelectedFiltersCount(currentParams);
});
